"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressBarLabels = void 0;
var typestyle_1 = require("typestyle");
var colors = require("../util/colors");
require("@tableau/fonts-tableau");
exports.progressBarLabels = typestyle_1.style({
    display: 'flex',
    justifyContent: 'space-between',
    color: colors.tableauGray11,
    fontSize: '12px',
    lineHeight: '18px',
    letterSpacing: '0.2px',
    fontStyle: 'normal',
    fontWeight: 400,
});
//# sourceMappingURL=ProgressBar.js.map